import React from 'react'

const WithConfig = WrappedComponent => {
    return class extends React.Component {
        constructor(props) {
            super(props)
            this.state = {
                config: window.$config,
            }
        }
        render() {
            return (
                <WrappedComponent config={this.state.config} {...this.props} />
            )
        }
    }
}

export default WithConfig
